import type { DatabaseEngineId } from '@/core/engines';

/**
 * Resolves the `DatabaseEngineId` for a query-editor tab's connection.
 *
 * `activeConnections` (the live, in-memory connected-session list) only
 * gains an entry once `connectToDatabase` resolves — a known e2e race
 * (`reference_e2e_active_connections`) where the store snapshot is briefly
 * empty at mount time even though the connection is otherwise healthy.
 * `savedConnections` (the persisted connection list) carries the engine
 * independent of the connect flow — it is populated by `loadConnections`/
 * `addConnection` well before any connect attempt — so it is a strictly more
 * reliable fallback than jumping straight to the `'mssql'` default.
 *
 * Resolution order: live active-connection engine > saved-connection engine
 * > `'mssql'` (last-resort default, preserved for a wholly unknown/missing
 * connectionId).
 */
export function resolveEngineIdForTab(
  activeConnectionEngine: string | undefined,
  savedConnectionEngine: string | undefined,
): DatabaseEngineId {
  return (activeConnectionEngine ?? savedConnectionEngine ?? 'mssql') as DatabaseEngineId;
}
